import React from "react";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

export const StatCard = ({ label, value, delta, icon: Icon, accent = "primary", testid }) => {
  const up = typeof delta === "number" && delta >= 0;
  const accentMap = {
    primary: "bg-primary text-primary-foreground",
    secondary: "bg-secondary text-secondary-foreground",
    green: "bg-green text-white",
    orange: "bg-orange text-white",
    blue: "bg-blue text-white",
    red: "bg-red text-white",
  };
  return (
    <div className="iso-card p-5 transition-shadow hover:shadow-card-lg" data-testid={testid}>
      <div className="flex items-start justify-between">
        <div>
          <div className="iso-label">{label}</div>
          <div className="mt-2 font-lexend text-3xl font-bold text-gray-900">{value}</div>
        </div>
        {Icon && (
          <div className={`flex size-10 items-center justify-center rounded-xl ${accentMap[accent]}`}>
            <Icon className="size-5" />
          </div>
        )}
      </div>
      {typeof delta === "number" && (
        <div className={`mt-3 inline-flex items-center gap-1 text-xs font-semibold ${up ? "text-green-dark" : "text-red-dark"}`}>
          {up ? <ArrowUpRight className="size-3.5" /> : <ArrowDownRight className="size-3.5" />}
          {Math.abs(delta).toFixed(1)}%
          <span className="ml-1 font-normal text-gray-400">vs last week</span>
        </div>
      )}
    </div>
  );
};
